<template>
    <div>
        <div class="calendar-attended-item-wrapper d-flex align-items-center">
            <BaseIcon
                name="calendar-check"
                size="4x"
                class="d-flex flex-column justify-content-center"
                style="margin: 5px;"
            >
            </BaseIcon>
            <div
                class="calendar-attended-item-content d-flex flex-column justify-content-center"
            >
                <h5>CV Feedback - 15 minutes</h5>
                <span class="calendar-attended-item-span"
                    >Ola Nordmann | Oslo, Norway</span
                >
                <span class="calendar-attended-item-span">March 15, 2019</span>
            </div>
        </div>
        <hr class="divider" />
    </div>
</template>

<script>
export default {
    name: 'AttendedAppointments',
};
</script>

<style scoped>
.calendar-attended-item-wrapper {
    padding: 20px;
}
.calendar-attended-item-content {
    margin-left: 20px;
}
.calendar-attended-item-span {
    font-size: 14px;
    color: #141414;
}
.divider {
    margin: 0;
    width: 100%;
    border-top: 1px solid #f3f3f3;
}
</style>
